import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { SelectElement } from "../../../components/selectElement2";
import { MediaDropzone } from "../../../components/MediaDropzone";

// Tipos de contenido soportados en las pantallas de llamado.
const TIPOS = [
    { value: 'youtube', label: 'YouTube', icon: 'fa-brands fa-youtube' },
    { value: 'video', label: 'Video', icon: 'fa-solid fa-film' },
    { value: 'imagen', label: 'Imagen', icon: 'fa-solid fa-image' },
];

const FORM_INICIAL = {
    tipoMedia: 'youtube',
    ideUbicacion: '',
    codigoUbicacion: '',
    videoCodigo: '',
    videoTitulo: '',
    duracionSeg: 10,
};

export const CrearVideoModal = ({ show, onClose, onSave, ubicaciones }) => {

    const [errors, setErrors] = useState({});
    const [form, setForm] = useState(FORM_INICIAL);

    const validateForm = () => {
        const newErrors = {};

        if (!form.ideUbicacion) {
            newErrors.ideUbicacion = 'Debe seleccionar una ubicación';
        }

        if (!form.videoTitulo.trim()) {
            newErrors.videoTitulo = 'Debe ingresar el título';
        }

        if (!form.videoCodigo.trim()) {
            newErrors.videoCodigo = form.tipoMedia === 'youtube'
                ? 'Debe ingresar el código del video'
                : 'Debe subir un archivo';
        }

        if (form.tipoMedia === 'imagen' && Number(form.duracionSeg) <= 0) {
            newErrors.duracionSeg = 'La duración debe ser mayor a 0 segundos';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const resetForm = () => {
        setForm(FORM_INICIAL);
        setErrors({});
    };

    useEffect(() => {
        if (!show) resetForm();
    }, [show]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: value
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    // Cambiar de tipo de contenido limpia el valor cargado (código o archivo)
    const cambiarTipo = (tipoMedia) => {
        setForm(prev => ({
            ...prev,
            tipoMedia,
            videoCodigo: '',
            duracionSeg: tipoMedia === 'imagen' ? (Number(prev.duracionSeg) || 10) : 10,
        }));
        setErrors({});
    };

    const handleSubmit = () => {

        if (!validateForm()) return;

        onSave({
            ...form,
            videoTitulo: form.videoTitulo.toUpperCase(),
            duracionSeg: Number(form.duracionSeg) || 10,
        });
    };

    const handleSelectUbicacion = (selected) => {
        setForm(prev => ({
            ...prev,
            ideUbicacion: selected.value,
            codigoUbicacion: selected.data
        }));

        setErrors(prev => ({
            ...prev,
            ideUbicacion: ''
        }));
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="lg"
            contentClassName="rounded-4 shadow-lg border-0"
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold fs-4">
                    Agregar Contenido
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form className="row g-3">

                    <Form.Group className="col-12">
                        <Form.Label>Tipo de contenido</Form.Label>
                        <div className="d-flex flex-wrap gap-2">
                            {TIPOS.map((t) => (
                                <Button
                                    key={t.value}
                                    type="button"
                                    size="sm"
                                    variant={form.tipoMedia === t.value ? 'primary' : 'outline-secondary'}
                                    onClick={() => cambiarTipo(t.value)}
                                >
                                    <i className={`${t.icon} me-2`}></i>
                                    {t.label}
                                </Button>
                            ))}
                        </div>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Sede/ubicación</Form.Label>
                        <SelectElement
                            options={ubicaciones}
                            name={`idUbicacion`}
                            isMulti={false}
                            closeOnMenuSelect={true}
                            value={ubicaciones.find(u => u.value === form.ideUbicacion)}
                            onChange={(selected) => handleSelectUbicacion(selected)}
                            classname="form-control form-control-lg"
                            isClearable={false}
                        />

                        {errors.ideUbicacion && (
                            <div className="invalid-feedback d-block">
                                {errors.ideUbicacion}
                            </div>
                        )}

                    </Form.Group>

                    {form.tipoMedia === 'youtube' ? (
                        <Form.Group className="col-md-6">
                            <Form.Label>Código o URL (YouTube)</Form.Label>
                            <Form.Control
                                name="videoCodigo"
                                placeholder="Ej: 7_4f23xhBwE o https://youtu.be/..."
                                value={form.videoCodigo}
                                onChange={handleChange}
                                isInvalid={!!errors.videoCodigo}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.videoCodigo}
                            </Form.Control.Feedback>
                        </Form.Group>
                    ) : (
                        <Form.Group className="col-12">
                            <MediaDropzone
                                key={form.tipoMedia}
                                tipoMedia={form.tipoMedia}
                                value={form.videoCodigo}
                                label={form.tipoMedia === 'imagen' ? 'Imagen para la pantalla' : 'Video para la pantalla'}
                                onChange={(url, tipo) => {
                                    setForm(prev => ({
                                        ...prev,
                                        videoCodigo: url,
                                        tipoMedia: tipo || prev.tipoMedia,
                                    }));
                                    setErrors(prev => ({ ...prev, videoCodigo: '' }));
                                }}
                            />
                            {errors.videoCodigo && (
                                <div className="invalid-feedback d-block">{errors.videoCodigo}</div>
                            )}
                        </Form.Group>
                    )}

                    {form.tipoMedia === 'imagen' && (
                        <Form.Group className="col-md-6">
                            <Form.Label>Duración en pantalla (segundos)</Form.Label>
                            <Form.Control
                                type="number"
                                min="1"
                                name="duracionSeg"
                                value={form.duracionSeg}
                                onChange={handleChange}
                                isInvalid={!!errors.duracionSeg}
                            />
                            <Form.Text className="text-muted">
                                Segundos que la imagen permanece en pantalla antes de pasar a la siguiente.
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                {errors.duracionSeg}
                            </Form.Control.Feedback>
                        </Form.Group>
                    )}

                    {form.tipoMedia === 'video' && (
                        <Form.Group className="col-md-6">
                            <Form.Text className="text-muted fst-italic">
                                Los videos se reproducen completos en la pantalla; no tienen duración configurable.
                            </Form.Text>
                        </Form.Group>
                    )}

                    <Form.Group className="col-md-6">
                        <Form.Label>Título </Form.Label>
                        <Form.Control
                            name="videoTitulo"
                            value={form.videoTitulo}
                            onChange={handleChange}
                            isInvalid={!!errors.videoTitulo}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.videoTitulo}
                        </Form.Control.Feedback>
                    </Form.Group>


                </Form>
            </Modal.Body>

            <Modal.Footer className="border-0">
                <Button variant="light" onClick={onClose}>
                    Cancelar
                </Button>

                <Button variant="primary" onClick={handleSubmit}>
                    Guardar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
